import React, { Component } from 'react';
import styled, { css, withTheme } from 'styled-components';
import LanguageStore from '../flux/LanguageStore';
import LanguageStoreActions from '../flux/LanguageStoreActions';
import UserStore from '../flux/UserStore';
import JwtStore from '../flux/JwtStore';
import UserStoreActions from '../flux/UserStoreActions';
import PageHeader from '../components/PageHeader';
import {
  DropDownButton,
  DropDownItem, DropDownItemCheck,
  DropDownItemsList,
} from '../components/DropDown';
import __ from '../utils/translator';
import ArrowDown from '../icons/ArrowDown';
import PageHeaderMenu, { menuItemStyle } from '../components/PageHeaderMenu';
import buttonMutedStyle from '../utils/buttonMutedStyle';
import DropDown from '../components/DropDown';
import { default as StoreIcon } from '../icons/Store';
import thronThumbnail from '../utils/thronThumbnail';
import Logout from '../icons/Logout';
import PageTitle from '../components/PageTitle';
import getCurrentBrand from '../utils/getCurrentBrand';
import RenderOnTablet from '../components/responsive/RenderOnTablet';
import themeResponsiveProperty
  from '../components/responsive/themeResponsiveProperty';
import RenderOnMobile from '../components/responsive/RenderOnMobile';
import NewsList from '../components/NewsList';
import ThronModal from '../components/ThronModal';
import ArrowRight from '../icons/ArrowRight';
import {Link, Redirect, Route, Switch, withRouter} from 'react-router-dom';
import Reports from './Reports';
import NavigationStore from '../flux/NavigationStore';
import NavigationStoreActions from '../flux/NavigationStoreActions';
import { default as ReportsIcon } from '../icons/Reports';
import { default as NotificationBellIcon } from '../icons/NotificationBell';
import { default as LanguageIcon } from '../icons/Language';
import { default as VideoManualIcon } from '../icons/VideoManual';
import { default as LogoutIcon } from '../icons/Logout';
import { default as PencilIcon } from '../icons/Pencil';
import Languages from "./Languages";
import Help from "./Help";
import MobileNews from "./MobileNews";
import Header from '../components/organisms/Header';

const VIDEO_MANUAL_TABLET_VALENTINO_DEFAULT = {
  contentId: 'f82bf4f3-31bb-4bfb-a485-15bbe41ebee6',
  pKey: 'VB12I8F',
};

const VIDEO_MANUAL_MOBILE_VALENTINO_DEFAULT = {
  contentId: '3037d937-1be3-4270-8d93-3dfbf484a074',
  pKey: 'VB12I8F',
};

const VIDEO_MANUAL_RED_DEFAULT = {
  contentId: 'b9f2a381-f7bd-48ec-b580-e353dc01421a',
  pKey: 'kxrxp1',
};

const videoManuals = {
  valentino: {
    tablet: {
      pt_PT: {
        contentId: 'f2b38087-b43a-45fb-aa8b-e97dabd0e22b',
        pKey: 'VB12I8F',
      },
      zh_CN: {
        contentId: '9b8ddd32-7ed5-499f-9ce3-f8d43bb4c43b',
        pKey: 'VB12I8F',
      },
      ja_JP: {
        contentId: 'e1103478-2948-4d61-a7cc-995cb6351d36',
        pKey: 'VB12I8F',
      },
      ko_KP: {
        contentId: '1b2be81c-dd0e-468c-a439-f6d1e4f956f3',
        pKey: 'VB12I8F',
      },
      default: VIDEO_MANUAL_TABLET_VALENTINO_DEFAULT,
    },
    mobile: {
      pt_PT: {
        contentId: '13162a06-7adf-4dd8-a3a7-ff8581d6175a',
        pKey: 'VB12I8F',
      },
      zh_CN: {
        contentId: 'b1783946-ad54-4756-b420-767ed5278780',
        pKey: 'VB12I8F',
      },
      ja_JP: {
        contentId: '9c50dba8-5e4b-4df8-8e8c-d85d517d32bb',
        pKey: 'VB12I8F',
      },
      ko_KP: {
        contentId: '81ddb1b4-6637-44fc-8a95-03ede45563c1',
        pKey: 'VB12I8F',
      },
      ar_AE: {
        contentId: '82643be1-17f8-4337-8217-2a5e20fe0b7f',
        pKey: 'VB12I8F',
      },
      ru_RU: {
        contentId: '0bf8bb29-0de2-4f4d-ba58-32f044c1ef0c',
        pKey: 'VB12I8F',
      },
      default: VIDEO_MANUAL_MOBILE_VALENTINO_DEFAULT,
    },
    default: VIDEO_MANUAL_TABLET_VALENTINO_DEFAULT,
  },
  red: {
    tablet: {
      ja_JP: {
        contentId: '8d05bf66-2193-4302-84cf-3fd9303bea5d',
        pKey: 'kxrxp1',
      },
      zh_CN: {
        contentId: '6ab5826b-576b-4a7d-8e5b-d12650a5ae3e',
        pKey: 'kxrxp1',
      },
      default: VIDEO_MANUAL_RED_DEFAULT,
    },
    mobile: {
      default: VIDEO_MANUAL_RED_DEFAULT,
    },
    default: VIDEO_MANUAL_RED_DEFAULT,
  },
};

const tabletStoreListStyle = {
  marginTop: 0,
  marginBottom: 0,
};

const mobileStoreListStyle = {
  marginTop: 0,
  marginBottom: 0,
  fontSize: '1.25rem',
};

function pickVideoManualAsset(
  brand,
  device,
  languageCode
) {
  if (videoManuals[brand][device] === undefined) {
    return videoManuals[brand]['default'];
  }

  if (videoManuals[brand][device][languageCode] === undefined) {
    return videoManuals[brand][device]['default'];
  }

  return videoManuals[brand][device][languageCode];
}

class ProfileComponent extends Component {
  state = {
    isLanguageDropdownOpen: false,
    currentLanguage: null,
    currentLanguageCode: null,
    languages: [],
    userUsername: null,
    userFirstName: '',
    userLastName: null,
    stores: [],
    thronModalOpened: false,
    assetClicked: null,
    news : [],
    reportCollectionId: null,
  };

  constructor(props){
    super(props);
    this.onMediaClick = this.onMediaClick.bind(this);
    this.onThronModalCloseButtonClick = this.onThronModalCloseButtonClick.bind(this);
  }

  subscriptions = [];

  componentDidMount() {
    NavigationStoreActions.getNavigation();
    LanguageStoreActions.fetch();
    UserStoreActions.fetch();

    this.subscriptions.push(NavigationStore.addListener(() => {
      this.setState({
        reportCollectionId: NavigationStore.getState().reports_collection_id,
      });
    }));

    this.subscriptions.push(LanguageStore.addListener(() => {
      this.setState({ languages: LanguageStore.getState() });
    }));

    this.subscriptions.push(UserStore.addListener(() => {
      const user = UserStore.getState();

      this.setState({
        userUsername: user.username,
        userFirstName: user.firstName,
        userLastName: user.lastName,
        stores: user.stores,
        currentLanguage: user.language,
        currentLanguageCode: user.language === null ? null : user.language.code,
        news: user.news,
      });
    }));

  }

  componentWillUnmount() {
    this.subscriptions.forEach(subscription => subscription.remove());
  }

  handleLanguageChange = language => {
    UserStoreActions.updateLanguage(language.code);

    this.setState({
      currentLanguage: language,
      currentLanguageCode: language.code,
    });
  };

  onMediaClick(asset) {
    this.setState({
      thronModalOpened: true,
      assetClicked: asset,
    });
  }

  onThronModalCloseButtonClick(){
    this.setState({thronModalOpened: false, assetClicked: null});
  }

  handleVideoManualClick = () => {
    const device = themeResponsiveProperty('mobile', 'tablet')(this.props);

    this.setState(state => ({
      thronModalOpened: true,
      assetClicked: pickVideoManualAsset(getCurrentBrand(), device, state.currentLanguageCode),
    }));
  };

  render() {
    return (
      <React.Fragment>
        <Header actions={themeResponsiveProperty(['close-fullscreen-modal'], undefined)(this.props)} />

        <PageTitle withTracking title="User area" />

        <PageHeader
          smallTitle
          compact
          crumbs={[__('Home'), __('User area')]}
          title={__('User area')}
          cover={themeResponsiveProperty(null, thronThumbnail(this.props.theme.pageHeaderContentId.profile))(this.props)}
          style={{ height: 'auto' }}>
          <PageHeader.MenuContainer>
            <PageHeaderMenuContainerInner>
              <UserNameGraphic>
                {(
                  this.state.userFirstName !== null &&
                  this.state.userLastName !== null
                ) ? (
                  `${this.state.userFirstName.charAt(0)}${this.state.userLastName.charAt(0)}`
                ) : this.state.userUsername !== null ? (
                  this.state.userUsername.charAt(0)
                ) : null}
              </UserNameGraphic>

              <RenderOnMobile>
                <h2 style={{ fontSize: '1.25rem' }}>
                  {this.state.userFirstName} {this.state.userLastName}
                </h2>
              </RenderOnMobile>

              <RenderOnTablet>
                <PageHeaderMenu style={{ justifyContent: 'flex-end', }}>
                  <a style={{ ...buttonMutedStyle, ...menuItemStyle, }} onClick={this.handleVideoManualClick}>
                    {__('Video Manual')}
                  </a>

                  <DropDown>
                    <DropDownButton
                      style={{
                        ...buttonMutedStyle,
                        ...menuItemStyle,
                        marginRight: 0,
                        paddingRight: '1rem',
                        paddingLeft: '1rem',
                      }}
                      onClick={() => this.setState({ isLanguageDropdownOpen: ! this.state.isLanguageDropdownOpen })}>
                      {__('Language')}
                      <ArrowDown width=".875rem" style={{ marginLeft: '.5rem', }} />
                    </DropDownButton>

                    <DropDownItemsList
                      open={this.state.isLanguageDropdownOpen}
                      style={{ right: 0, top: '100%', }}>
                      {this.state.languages.map(language => (
                        <DropDownItem
                          key={language.code}
                          name={language.code}
                          selected={this.state.currentLanguageCode === language.code}
                          onClick={() => this.handleLanguageChange(language)} >
                          {__(language.name)}

                          <span style={{
                            paddingLeft: '.25rem',
                            visibility: this.state.currentLanguageCode === language.code ? null : 'hidden',
                          }}>
                            <DropDownItemCheck />
                          </span>
                        </DropDownItem>
                      ))}
                    </DropDownItemsList>
                  </DropDown>

                  <Link to="/logout">
                    <button style={{ ...buttonMutedStyle, ...menuItemStyle, }}>
                      {__('Logout')}
                      <Logout width=".875rem" style={{ marginLeft: '.5rem', }} />
                    </button>
                  </Link>
                </PageHeaderMenu>
              </RenderOnTablet>
            </PageHeaderMenuContainerInner>
          </PageHeader.MenuContainer>
        </PageHeader>

        <UserInfoContainer>
          <UserInfoContainerInner>
            <RenderOnTablet>
              <h1>{this.state.userFirstName} {this.state.userLastName}</h1>
            </RenderOnTablet>

            {this.state.stores.length > 0 && (
              JwtStore.isStoreAssistant() || JwtStore.isStoreManager() || JwtStore.isOffice()
            ) && (
              <StoreListContainer>
                <StoreListTitle>
                  <Store />
                  {this.state.stores.length === 1 ? __('Store') : __('Stores')}
                </StoreListTitle>
                <StoreList>
                  {this.state.stores.map(store => (
                    <StoreListItem key={store.id}>{store.prettyName}</StoreListItem>
                  ))}
                </StoreList>
              </StoreListContainer>
            )}
          </UserInfoContainerInner>
        </UserInfoContainer>

        <RenderOnMobile>
          <List>
            {(JwtStore.isStoreAssistant() || JwtStore.canViewReport() || JwtStore.isOffice()) && (
              <li>
                <Link
                  to={this.state.reportCollectionId !== null ? `/reports/seasonal/${this.state.reportCollectionId}` : '#'}
                >
                  <button style={buttonMutedStyle}>
                    <ReportsIcon/>
                    <h3>{__('Reports')}</h3>
                    <ArrowRight/>
                  </button>
                </Link>
              </li>
            )}
            <li>
              <Link to="/news">
                <button style={buttonMutedStyle}>
                  <NotificationBellIcon />
                  <h3>{__('News')}</h3>
                  <ArrowRight />
                </button>
              </Link>
            </li>
            <li>
              <Link to="/languages">
                <button style={buttonMutedStyle}>
                  <LanguageIcon />
                  <h3>{__('Language')}</h3>
                  <ArrowRight />
                </button>
              </Link>
            </li>
            <li>
              <button style={buttonMutedStyle} onClick={this.handleVideoManualClick}>
                <VideoManualIcon />
                <h3>{__('Video manual')}</h3>
                <ArrowRight />
              </button>
            </li>
            <li>
              <Link to="/logout">
                <button style={buttonMutedStyle}>
                  <LogoutIcon />
                  <h3>{__('Logout')}</h3>
                  <ArrowRight />
                </button>
              </Link>
            </li>
          </List>

          <Link to='/help'>
            <button style={{...buttonMutedStyle, width: '100%', marginBottom: '2rem' }}>
              <NeedHelpContainer>
                <span>{__('Need help? Write us!')}</span>
                <PencilIcon />
              </NeedHelpContainer>
            </button>
          </Link>
        </RenderOnMobile>

        <RenderOnTablet>
          <NewsList
            items={this.state.news}
            onMediaClick={this.onMediaClick}
          />
        </RenderOnTablet>

        {this.state.thronModalOpened && (
          <ThronModal asset={this.state.assetClicked} onCloseButtonClick={this.onThronModalCloseButtonClick} />
        )}
      </React.Fragment>
    );
  }
}

const ProfileComponentWithHOC = withTheme(ProfileComponent);

export default withTheme(withRouter(function Profile(props) {
  return (
    props.theme.isMobile ? (
      <React.Fragment>
        <Route exact path="/" component={ProfileComponentWithHOC} />
        <Route path="/reports/:collectionType/:parentId/:region?/:country?/:store?/:username?" component={Reports} />
        <Route path="/news" component={MobileNews}/>
        <Route path="/languages" component={Languages} />
        <Route path="/help" component={Help} />
      </React.Fragment>
    ) : props.theme.isTablet ? (
      <ProfileComponentWithHOC {...props} />
    ) : null
  );
}));

const PageHeaderMenuContainerInner = styled.div`
  max-width: 47.5rem;
  margin-top: ${themeResponsiveProperty('1.5rem', '9rem')};
  margin-right: auto;
  margin-left: auto;

  ${props => props.theme.isMobile && css`
    display: flex;
    flex-direction: column;
    align-items: center;
  `};
`;

const UserNameGraphic = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: ${themeResponsiveProperty('4.25rem', '6.75rem')};
  height: ${themeResponsiveProperty('4.25rem', '6.75rem')};
  font-size: ${themeResponsiveProperty('2rem', '3rem')};

  background-color: #545454;
  color: rgba(255, 255, 255, .6);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

  ${themeResponsiveProperty(css`
    z-index: 3;
    position: relative;
  `, css`
    z-index: 3;
    position: absolute;
    top: -1rem;
  `)};
`;

const UserInfoContainer = styled.div`
  z-index: 2;
  position: relative;
  box-shadow: ${themeResponsiveProperty(null, '0 .25rem 1rem -.25rem rgba(0,0,0,.25)')};
`;

const UserInfoContainerInner = styled.div`
  max-width: 60.5rem;
  margin-right: auto;
  margin-left: auto;
  padding: ${themeResponsiveProperty('0 1.25rem 1.25rem 4.125rem', '3.25rem 1.25rem 1.25rem 6.5rem')};

  ${props => props.theme.isMobile && css`
    > h1 {
      margin-top: 0;
    }
  `};
`;

const StoreListContainer = styled.div``;

const StoreListTitle = styled.h3`
  position: relative;
  display: flex;
  align-items: center;
  margin: 0;
  font-family: 'Din-Light', sans-serif;
`;

const Store = styled(StoreIcon)`
  position: absolute;
  left: ${themeResponsiveProperty('-2rem', '-3.34rem')};
  transform: translateX(-50%);
  width: ${themeResponsiveProperty('1.25rem', '1.75rem')};
  height: ${themeResponsiveProperty(null, '1.75rem')};
`;

const StoreList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

const StoreListItem = withTheme(({ children, ...props }) => (
  <li {...props}>
    <h2 style={themeResponsiveProperty(mobileStoreListStyle, tabletStoreListStyle)(props)}>{children}</h2>
  </li>
));

const List = styled.ul`
  padding: .625rem 1.25rem;
  list-style: none;

  > li:last-child {
    margin-bottom: 0;
  }

  > li button {
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: .8125rem;
    text-align: start;
  }

  > li h3 {
    flex: 1;
    margin-top: 0;
    margin-bottom: 0;
    padding-right: .5rem;
    padding-left: .5rem;
    font-weight: normal;
  }

  > li svg {
    width: 1.25rem;
    height: 1.25rem;
    margin: .5rem;
  }

  > li svg:first-child {
    margin-left: 0;
  }

  > li svg:last-child {
    margin-right: 0;
  }
`;

const NeedHelpContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 1.25rem;
  padding: 1.125rem 1.25rem;
  border-radius: .3125rem;
  border: .0625rem solid #000;

  > svg {
    width: 1rem;
    height: 1rem;
  }
`;
